import Image from 'next/image';

type Testimonial = {
  avatar: string;
  name: string;
  title: string;
  testimonial: string;
};

type TestimonialsGridProps = {
  testimonials: Testimonial[];
  grid_columns?: number;
  add_background?: boolean;
  add_bottom_border?: boolean;
};

export function TestimonialsGrid({ 
  testimonials, 
  grid_columns = 3,
  add_background = false,
  add_bottom_border = false
}: TestimonialsGridProps) {
  const gridColsClass = {
    1: 'grid-cols-1',
    2: 'md:grid-cols-2',
    3: 'md:grid-cols-2 lg:grid-cols-3',
    4: 'md:grid-cols-2 lg:grid-cols-4',
  }[grid_columns] || 'md:grid-cols-2 lg:grid-cols-3';

  const content = (
    <div className={`grid grid-cols-1 ${gridColsClass} gap-6`}>
      {testimonials.map((testimonial, idx) => (
        <div 
          key={idx} 
          className="flex flex-col gap-4 bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow"
        >
          <div className="flex items-center gap-4">
            <div className="relative w-16 h-16 rounded-full overflow-hidden bg-gray-200 shrink-0">
              <img
                src={testimonial.avatar}
                alt={testimonial.name}
                className="object-cover"
              />
            </div>
            <div className="flex flex-col">
              <h4 className="text-lg font-bold text-primary-700">{testimonial.name}</h4>
              <p className="text-sm text-gray-600">{testimonial.title}</p>
            </div>
          </div>
          <p className="text-gray-700 leading-relaxed italic">
            &quot;{testimonial.testimonial}&quot;
          </p>
        </div>
      ))}
    </div>
  );

  if (add_background) {
    return (
      <section 
        className={`w-screen relative left-1/2 right-1/2 -mx-[50vw] bg-gradient-to-b from-[rgba(237,237,249,0)] to-[#DEE5E8] py-12 ${
          add_bottom_border ? 'border-b border-gray-200' : ''
        }`}
      >
        <div className="container max-w-7xl mx-auto px-4">
          {content}
        </div>
      </section>
    );
  }

  return (
    <div className={add_bottom_border ? 'pb-8 border-b border-gray-200' : ''}>
      {content}
    </div>
  );
}
